<template>
    <div>
        <BlogHeader :index = "'4'"></BlogHeader>
        <el-progress :percentage="answerNum" color="#67c23a" style="margin-top: 60px;position:fixed;z-index:1005;width: 100%;top:0px;" :show-text="false" v-if="isTest"></el-progress>
        <div style="margin: 40px 10% 0 10%;padding: 50px 30px 30px 30px;" class="test">
            <div v-for="(item,key) in list" :key="key" v-if="isTest">
                <el-card shadow="hover" :id="'answers'+(key+1)">
                    <div class="question">
                        <el-badge is-dot class="item" type="success" :hidden="select[key]==undefined"><span class="question_num">{{key+1}}</span></el-badge><span class="question_text">{{item.question}}</span>
                        <i class="el-icon-error" style="color: red;" v-if="status[key]==0"></i>
                        <i class="el-icon-success" style="color: green;" v-if="status[key]==1"></i>
                        <i class="el-icon-warning" style="color: orange;" v-if="status[key]==2"></i>
                    </div>
                    <div class="answers">
                        <el-radio-group v-model="select[key]" :disabled="testStatus==2" v-for="(answerlist,ke) in item.answers"  :key="ke" @change="changeStatus(key)">
                            <el-radio :label="ke">{{answerlist}}</el-radio>
                        </el-radio-group>
                    </div>
                </el-card>
            </div>
            <div v-if="!isTest">
                <el-card shadow="hover" style="margin-bottom: 100px">
                    <el-alert
                            :title="$t('know')"
                            type="warning"
                            center
                            :closable="false"
                            show-icon style="margin-bottom: 30px;margin-top: 20px;">
                    </el-alert>
                    <el-alert
                            type="success"
                            title="1.结合网上和平时自己的工作中总结一些php,mysql,html相关问题，供大家学习，或者检测自己的薄弱点。">
                    </el-alert>
                    <el-alert
                            type="success"
                            title="2.自己找的问题可能不全面，所以希望考试的同学可以提交自己平常遇到的问题或者容易忽略的知识点来分享给大家。">
                    </el-alert>
                    <el-alert
                            type="success"
                            title="3.在考完试最后会有个填写自己遇到问题的表单，如果没有提交的，或者随笔乱写的，我会审核，审核没通过的，只能看到马上考试分数，不能看到正确答案。通过的会发送正确答案到你指定的邮箱！">
                    </el-alert>
                    <el-alert
                            type="success"
                            title="4.题目都是单选，每个题目一分。">
                    </el-alert>
                    <el-alert
                            type="success"
                            title="5.如果试题有不正确的地方，欢迎大家批评指正留言！">
                    </el-alert>
                </el-card>
            </div>
        </div>
        <div style="text-align: center;margin-bottom: 30px;">
            <el-button-group>
                <el-button type="primary" icon="el-icon-caret-right" @click="beginTest" v-if="testStatus==0">{{$t('begintest')}}</el-button>
                <el-button type="primary" icon="el-icon-check" @click="giveAnswer" v-if="testStatus==1">{{$t('giveanswer')}}</el-button>
                <el-button type="primary" icon="el-icon-warning" v-if="testStatus==2">{{$t('endtest')}}</el-button>

                <el-button type="primary" icon="el-icon-refresh" @click="retest" v-if="testStatus==1">{{$t('retest')}}</el-button>
                <el-button type="primary" icon="el-icon-view" @click="endTest" v-if="testStatus==2">{{$t('detail')}}</el-button>
            </el-button-group>
        </div>
        <el-dialog :title="$t('thank')" :visible.sync="dialogTableVisible">
            <el-form :model="questionForm" label-width="80px" ref="questionForm">
                <el-form-item
                        prop="user"
                        :label="$t('email')"
                        :rules="[
      { required: true, message: $t('email_r1'), trigger: 'blur' },
      { type: 'email', message: $t('email_r2'), trigger: ['blur', 'change'] }
    ]"
                >
                    <el-input v-model="questionForm.user" maxlength="100" size="small" :placeholder="$t('useemail')" clearable></el-input>
                </el-form-item>
                <el-form-item
                        prop="question"
                        :label="$t('question')"
                        :rules="questionResule"
                >
                    <el-input :placeholder="$t('input')" maxlength="100" v-model="questionForm.question" class="input-with-select"  size="small" clearable>
                        <el-select v-model="questionForm.type" slot="prepend" :placeholder="$t('questionstatus')" style="width: 100px;">
                            <el-option label="php" value="1"></el-option>
                            <el-option label="mysql" value="2"></el-option>
                            <el-option label="html" value="3"></el-option>
                            <el-option label="linux" value="4"></el-option>
                            <el-option :label="$t('other')" value="5"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item
                        v-for="(answer, index) in questionForm.answers"
                        :label="$t('answerlist') + (index+1)"
                        :key="answer.key"
                        :prop="'answers.' + index + '.value'"
                        :rules="answerResule"
                >
                    <el-input :placeholder="$t('input')"  maxlength="100" v-model="answer.value" class="input-with-select"  size="small" clearable>
                        <el-select v-model="answer.isRight" slot="prepend" :placeholder="$t('select')" style="width: 100px;">
                            <el-option :label="$t('rightanswer')" value="1"></el-option>
                            <el-option :label="$t('wronganswer')" value="0"></el-option>
                        </el-select>
                        <el-button slot="append" icon="el-icon-close" @click.prevent="removeAnswer(answer)">{{$t('del')}}</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('questionForm')" size="small">{{$t('submitquestion')}}</el-button>
                    <el-button @click="addAnswer" icon="el-icon-plus" size="small">{{$t('addquestion')}}</el-button>
                    <el-button @click="resetForm('questionForm')" icon="el-icon-refresh" size="small">{{$t('reset')}}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <BlogFoot></BlogFoot>
    </div>
</template>

<script>
    import common from '../config/common.js';
    import BlogHeader from './common/BlogHeader.vue';
    import BlogFoot from './common/BlogFoot.vue';
    export default {
        name: "Test",
        data () {
            var checkAnswer = (rule, value, callback) => {
                if (!value)return callback(new Error(this.$t('noanswer')));
                var num = rule.field.replace(/[^0-9]/ig,"");
                if(this.questionForm.answers[num].isRight=='')return callback(new Error(this.$t('selecttype')));
                var j = 0;
                for(var i=0;i<this.questionForm.answers.length;i++){
                    if(this.questionForm.answers[i].isRight==1){
                        if(++j>1)return callback(new Error(this.$t('oneright')));
                    }
                }
                if(j==0&&this.questionForm.answers.length>=3)return callback(new Error(this.$t('noright')));
                callback();
            };
            var checkQuestion = (rule, value, callback) => {
                if (!value)return callback(new Error(this.$t('noquestion')));
                if(this.questionForm.type=='')return callback(new Error(this.$t('questiontype')));
                callback();
            };
            return {
                select: [],
                list: [],
                status: [],
                dialogTableVisible: false,
                isTest: false,
                testStatus: 0,
                answerNum: 0,
                testTime: 0,
                uid: '',
                result: '',
                answerType:1,
                questionForm: {
                    answers: [{
                        value: '',
                        isRight:''
                    }],
                    question: '',
                    user: '',
                    type: '',
                },
                answerResule:{ validator: checkAnswer, trigger: ['blur', 'click'] },
                questionResule:{ validator: checkQuestion, trigger: ['blur', 'click'] }
            }
        },
        components:{
            BlogFoot,
            BlogHeader
        },methods:{
            endTest(){
                this.$confirm(this.$t('lookanswer'), '', {
                    confirmButtonText: this.$t('givequestion'),
                    cancelButtonText: this.$t('lookgrade'),
                    title:'',
                    showClose:false,
                    type: 'warning'
                }).then(() => {
                    this.dialogTableVisible = true;
                }).catch(() => {
                    this.$message({
                        message: this.result,
                        type: 'success'
                    });
                });

            },
            getList(){
                this.$axios.get(common.apiurl+'/api/question/list').then((response)=>{
                    if(response.data.code==0){
                        this.list = response.data.data;
                        this.uid = response.data.uid;
                    }
                    else {
                        this.$message({
                            message: this.$t('common.neterror'),
                            type: 'warning'
                        });
                    }
                }).catch((error)=>{
                    this.$message({
                        message: this.$t('common.neterror'),
                        type: 'warning'
                    });
                });
            },
            retest() {
                this.select=[];
                this.getList();
                for (var i=0;i<this.list.length;i++){
                    this.$set(this.status,i,undefined);
                }
            },
            changeStatus(key){
                var num = 0;
                for (var i=0;i<this.list.length;i++){
                    if(this.select[i]!=undefined){
                        num++;
                    }
                }
                this.answerNum = (num/this.list.length).toFixed(2)*100;
                this.$set(this.status,key,undefined);
            },beginTest(){

                this.$confirm(this.$t('istest'), '', {
                    confirmButtonText: this.$t('conformtest'),
                    cancelButtonText: this.$t('thinkabout'),
                    title:this.$t('testtitle'),
                    type: 'warning'
                }).then(() => {
                    this.isTest = true;
                    this.testTime = new Date().getTime();
                    this.testStatus = 1;
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('cancletest')
                    });
                });
            },
            giveAnswer(){

                this.$confirm(this.$t('giveanswers'), '', {
                    confirmButtonText: this.$t('conformgive'),
                    cancelButtonText: this.$t('thinkabout'),
                    title:this.$t('submitanswer'),
                    type: 'warning'
                }).then(() => {
                    for (var i=0;i<this.list.length;i++){
                        if(this.select[i]==undefined){
                            this.$set(this.status,i,2);
                        }else{
                            this.$set(this.status,i,undefined);
                        }
                    }
                    for (var i=0;i<this.list.length;i++){
                        if(this.select[i]==undefined){
                            if(i==0)i=1;
                            document.querySelector("#answers"+i).scrollIntoView(true);
                            this.$message.error(this.$t('miss'));
                            return ;
                        }
                    }
                    this.testStatus = 2;
                    this.$axios.post(common.apiurl+'/api/answer','answer='+this.select+'&user='+this.uid).then((response)=>{
                        if(response.data.code==0){
                            var right = 0;
                            for (var i=0;i<this.list.length;i++){
                                if(response.data.data[i]){
                                    right++;
                                    this.$set(this.status,i,1);
                                }else{
                                    this.$set(this.status,i,0);
                                }
                            }
                            this.result = '总共耗时'+((new Date().getTime()-this.testTime)/60000).toFixed(1)+'分钟，总分为'+this.list.length+'分,成绩为'+right+'分';
                            this.$message({
                                message: this.result,
                                type: 'success'
                            });
                        }
                        else {
                            this.$message({
                                message: this.$t('common.neterror'),
                                type: 'warning'
                            });
                        }
                    }).catch((error)=>{
                        this.$message({
                            message: this.$t('common.neterror'),
                            type: 'warning'
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('cancletest')
                    });
                });

            },submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.questionForm.answers.length<3||this.questionForm.answers.length>5){
                            this.$message({
                                message: this.$t('threetofive'),
                                type: 'error'
                            });
                            return ;
                        }
                        this.$axios.post(common.apiurl+'/api/addquestion','question='+JSON.stringify(this.questionForm)).then((response)=>{
                            if(response.data.code==0){
                                this.dialogTableVisible = false;
                                this.$message({
                                    message: this.$t('submitok'),
                                    type: 'success'
                                });
                            }
                            else {
                                this.$message({
                                    message: this.$t('submitfail'),
                                    type: 'warning'
                                });
                            }
                        }).catch((error)=>{
                            this.$message({
                                message: this.$t('common.neterror'),
                                type: 'warning'
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            removeAnswer(item) {
                var index = this.questionForm.answers.indexOf(item)
                if (index !== -1) {
                    this.questionForm.answers.splice(index, 1)
                }
            },
            addAnswer() {
                if(this.questionForm.answers.length>4){
                    this.$message({
                        message: this.$t('leastfive'),
                        type: 'error'
                    });
                    return ;
                }
                this.questionForm.answers.push({
                    value: '',
                    isRight: ''
                });
            }
        },created(){
            window.scrollTo(0,0);
            this.getList()
        }
    }
</script>

<style scoped>
    .test >>> .el-card{
        margin-bottom: 15px;
    }
    .question_text{
        margin-left: 10px;
    }
    .question{
        margin-bottom: 10px;
    }
    .answers{
        text-align: center;
    }
    .question_num{
        background-color: #AF441E;
        color: #fff;
        display: inline-block;
        font-size: 12px;
        width: 14px;
        line-height: 18px;
        padding: 2px 4px;
        text-align: center;
        white-space: nowrap;
        border: 1px solid #fff;
    }
    .test >>> .el-radio__label{
        margin-right: 30px;
    }
    .test >>> .el-alert{
        margin-bottom: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Test.vue